import { Pipe, PipeTransform } from '@angular/core';
import { util } from '../util';
import _ from 'underscore';

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
  public transform(items:any[], searchFilter:string, filterBy:string):any {
    // if array is undefined or empty or there is no filter
    // then just return items as it is
    if (!items?.length || !searchFilter) {
      return items;
    }

    const clonedItems:any[] = util.deepClone(items);

    // return items based on filter value
    return _.filter(clonedItems, (data:any):boolean => {
      if (!filterBy) {
        return _.findIndex([ data ], searchFilter) > -1;
      }

      return String(data[filterBy]).toLowerCase()?.includes(searchFilter?.toLowerCase());
    });
  }
}